import React, { useState, useEffect } from "react";
import SaveIcon from '@mui/icons-material/SaveRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import TabContainer from '@mui/material/TableContainer';
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { NumericFormat, PatternFormat } from 'react-number-format';
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import ApiAgency from "../../../core/api/api.agency";
import ApiAccount from "../../../core/api/api.account";
import ApiTransaction from "../../../core/api/api.transaction";
import moment from "moment-jalaali";
import { tools } from "../../../core/utils/tools";

export const EditModal = ({ showModalTransaction, setShowModalTransaction, selectedTransaction }) => {
  const [completionDate, setcompletionDate] = useState();
  const handleClose = () => {
    setShowModalTransaction(false);
  }
  const { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch } = useForm({
    defaultValues: { id: 0 }
  });
  const [lAgency, setLAgency] = useState([]);
  const watchSourceAgencyId = watch("sourceAgencyId", undefined);
  const watchDestinationAgencyId = watch("destinationAgencyId", undefined);
  const [lSourceAccount, setLSourceAccount] = useState([]);
  const [lDestinationAccount, setLDestinationAccount] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        // دریافت لیست آژانس ها
        const data1 = await ApiAgency.getAllAgency({ PageNumber: 1, PageSize: 100 });
        setLAgency(data1.data);
        // - - - - - - - - - - - - - - - - - 
        if (selectedTransaction > 0) {
          // دریافت اطلاعات تراکنش جهت ویرایش
          let response = await ApiTransaction.getTransactionById(selectedTransaction);
          if (response.succeeded == true) {
            if (moment(response.data.completionDate, 'jYYYY/jMM/jDD').isValid()) {
              let completionDate = response.data.completionDate.split('/');
              setValue("completionDate", { year: completionDate[0], month: completionDate[1], day: completionDate[2] });
            }
            // مقدار اولیه ویرایش تراکنش
            setValue("id", response.data.id);
            //setValue("sourceAgencyId", "2002");
            setValue("sourceAgencyId", response.data.sourceAgencyId);
            setValue("sourceAccountId", response.data.sourceAccountId);
            setValue("destinationAgencyId", response.data.destinationAgencyId);
            setValue("destinationAccountId", response.data.destinationAccountId);

            setValue("completionTime", response.data.completionTime);
            setValue("amount", response.data.amount + "");
            //setValue("amount", response.data.amount);
          }
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  useEffect(() => {
    (async () => {
      // دریافت لیست حساب ها
      if (watchSourceAgencyId != undefined) {
        let response = await ApiAccount.getAccountByAgencyId(watchSourceAgencyId);
        setLSourceAccount(response.data);
      }
    })();
    return () => { };
  }, [watchSourceAgencyId]);

  useEffect(() => {
    (async () => {
      // دریافت لیست حساب ها
      if (watchDestinationAgencyId != undefined) {
        let response = await ApiAccount.getAccountByAgencyId(watchDestinationAgencyId);
        setLDestinationAccount(response.data);
      }
    })();
    return () => { };
  }, [watchDestinationAgencyId]);

  const onSubmit =
    async (data) => {
      try {

        if (data.completionDate !== null && typeof data.completionDate === "object") {
          data.completionDate = tools.DateFormat(data.completionDate);
        }
        data.amount = data.amount.replaceAll(",", "")
        if (!_.isEmpty(data.sourceAccountId) && data.sourceAccountId === data.destinationAccountId) {
          SwalMessage({ title: "حساب مبدا و مقصد نمی تواند یکسان باشد", iSsuccess: false });
          return;
        }

        let response = await ApiTransaction.updateTransaction(data);
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      } catch (error) {
      }
    }

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size='md' onHide={handleClose} show={showModalTransaction} >
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title> ویرایش تراکنش</Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <TabContainer className=' border border-top-0 py-3 border-bottom-radius'>
              <Col xs='12'>
                <Row >
                  <Col xs='12'>
                    <Controller
                      name="sourceAgencyId"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          select
                          label="انتخاب آژانس مبدا"
                          margin="normal"
                          variant="outlined"
                          size='small'
                          value={value || ''}
                          onInput={onChange}
                          onChange={onChange}
                        >
                          <MenuItem key={99} value={''} > --  </MenuItem>
                          {lAgency?.map((item, index) =>
                            <MenuItem key={index} value={item.id} >{item.name} </MenuItem>
                          )}
                        </TextField>
                      )}
                    />
                  </Col>
                  <Col xs='12'>
                    <Controller
                      name="sourceAccountId"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          select
                          label="انتخاب حساب مبدا"
                          margin="normal"
                          variant="outlined"
                          size='small'
                          value={value || ""}
                          onInput={onChange}
                          onChange={onChange}
                        >
                          <MenuItem key={99} value={""} > --  </MenuItem>
                          {lSourceAccount?.map((item, index) =>
                            <MenuItem key={index} value={item.id} >{"نام : " + item.accountOwnerName + " - شماره حساب : " + item.accountNumber} </MenuItem>
                          )}
                        </TextField>
                      )}
                    />
                  </Col>
                  <Col xs='12'>
                    <Controller
                      name="destinationAgencyId"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          select
                          label="انتخاب آژانس مقصد"
                          margin="normal"
                          variant="outlined"
                          size='small'
                          value={value || ""}
                          onInput={onChange}
                          onChange={onChange}
                        >
                          <MenuItem key={99} value={""} > --  </MenuItem>
                          {lAgency?.map((item, index) =>
                            <MenuItem key={index} value={item.id} >{item.name} </MenuItem>
                          )}
                        </TextField>
                      )}
                    />
                  </Col>
                  <Col xs='12'>
                    <Controller
                      name="destinationAccountId"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          select
                          label="انتخاب حساب مقصد"
                          margin="normal"
                          variant="outlined"
                          size='small'
                          value={value || ""}
                          onInput={onChange}
                          onChange={onChange}
                        >
                          <MenuItem key={99} value={""} > --  </MenuItem>
                          {lDestinationAccount?.map((item, index) =>
                            <MenuItem key={index} value={item.id} >{"نام : " + item.accountOwnerName + " - شماره حساب : " + item.accountNumber} </MenuItem>
                          )}
                        </TextField>
                      )}
                    />
                  </Col>
                  <Col xs='12'>

                    <Controller
                      name="completionDate"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <ShamsiDatePicker
                          value={value}
                          onChange={onChange}
                          placeholder=' تاریخ پرداخت'
                        />
                      )}
                    />
                    {errors.completionDate && <span>لطفا تاریخ پرداخت را وارد نمایید</span>}

                  </Col>
                  <Col xs='12'>
                    <Controller
                      name="completionTime"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <PatternFormat format="##:##" mask=""
                          customInput={TextField}
                          label="زمان پرداخت"
                          type="search"
                          onKeyDown={(e) => {
                            if (e.key === "Escape") {
                              e.stopPropagation()
                            }
                          }}
                          variant="outlined"
                          margin="normal"
                          className="w-100"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                    {errors.completionTime && <span>زمان پرداخت نمیتواند خالی باشد</span>}
                  </Col>
                  <Col xs='12'>
                    <Controller
                      name="amount"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <NumericFormat
                          customInput={TextField}
                          label="مبلغ"
                          variant="outlined"
                          margin="normal"
                          className="w-100"
                          size="small"
                          thousandSeparator=","
                          decimalScale="0"
                          value={value || ""}
                          onChange={onChange}
                          type="search"
                          onKeyDown={(e) => {
                            if (e.key === "Escape") {
                              e.stopPropagation()
                            }
                          }}
                        />
                      )}
                    />
                    {errors.amount && <span>مبلغ نمیتواند خالی باشد</span>}
                  </Col>
                  <Col xs='12'>
                    <Controller
                      name="description"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="توضیحات"
                          margin="normal"
                          variant="outlined"
                          size='small'
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </TabContainer>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon />  ذخیره
                        </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon />  بستن
                        </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}
